import { AppealRecord } from "./types";

export enum RestStatus {
  NOT_STARTED = 'not started',
  LOADING = 'loading',
  LOADED = 'loaded',
  LOAD_FAILED = 'loadFailed',
  SAVING = 'saving',
  SAVED = 'saved',
  SAVE_FAILED = 'saveFailed'
};

export enum LoadStatus {
  NOT_LOADED = "not loaded",
  IN_PROGRESS = "in progress",
  SUCCESS = "success",
  FAILED = "failed"
};

export enum SaveStatus {
  IDLE = "idle",
  IN_PROGRESS = "in progress",
  SUCCESS = "success",
  FAILED = "failed"
};

export type RestCallStatus = {
  status: RestStatus;
  source?: string;
  requestId?: string;
  error?: string
}

export type PatchOperation = {
  op: 'add' | 'remove' | 'replace';
  path: string;
  value?: any;
}

export function removeNull<T extends object>(obj: T | any) {
  Object.keys(obj).forEach(k => {
    const key = k as keyof T
    if (obj[key] && typeof obj[key] === 'object') removeNull(obj[key])
    else if (obj[key] == null) delete obj[key];
  })
  return obj;
}

export const isValuationAppeal = (appeal: AppealRecord): boolean => {
  return appeal.valuation.appealing === true && !(appeal.deduction.abatement || appeal.deduction.disabledVeteranExemption || appeal.deduction.seniorCitizenOrDisabledPerson || appeal.deduction.veteranDeduction);
}